import script from "./TutorProgrammes.vue?vue&type=script&setup=true&lang=js"
export * from "./TutorProgrammes.vue?vue&type=script&setup=true&lang=js"

import "./TutorProgrammes.vue?vue&type=style&index=0&id=de074138&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-de074138"]])

export default __exports__